let context = require.context('./', true, /\.component.js$/);
context.keys().forEach(context);
